<app-header bgColor="rgb(90 99 255 / 59%)"></app-header>
<section id="partner" class="partner-wrapper">
  <div class="partner-title-wrapper">
    <div class="container">
      <h3 class="text-center partner-title" translate>partner_title</h3>
    </div>
  </div>
  <div class="container">
    <div class="row justify-content-center ">
      <div class="col-lg-7">
        <h2 class="fw-semibold text-black text-center partner-cont" translate>partner_best_title</h2>
        <p class="fw-medium text-center subtitle  three-card" translate>partner_best_desc</p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-lg-4">
        <div class="paetner-info text-center">
          <img src="/assets/images/new/audience.svg" class="img-fluid mb-3 paetner-img" alt="">
          <h4 class="font-20 fw-bold text-black my-3 text-center" translate>partner_audience</h4>
          <p class="font-15 fw-medium text-center px-lg-3 card-para" translate>partner_audience_info</p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="paetner-info text-center">
          <img src="/assets/images/new/news.svg" class="img-fluid mb-3 paetner-img" alt="">
          <h4 class="font-20 fw-bold text-black my-3 text-center" translate>partner_best</h4>
          <p class="font-15 fw-medium text-center px-lg-3 card-para" translate>partner_best_info</p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="paetner-info text-center">
          <img src="/assets/images/new/featured.svg" class="img-fluid mb-3 paetner-img" alt="">
          <h4 class="font-20 fw-bold text-black my-3 text-center" translate>partner_featured</h4>
          <p class="font-15 fw-medium  text-center px-lg-3 card-para" translate>partner_featured_info</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center partner-need">
      <div class="col-lg-8">
        <h2 class="fw-semibold text-black mb-4 mt-lg-0 font-48 text-center " translate>partner_showcase_title</h2>
        <p class="fw-medium text-center subtitle px-md-2" translate>partner_showcase_desc1</p>
        <p class="fw-medium text-center subtitle" translate>partner_showcase_desc2</p>
      </div>
    </div>
    <div class="form-wrapper p-5">
      <h2 class="fw-semibold text-black mb-5 mt-lg-0 text-center part-title" translate>partner_form_title</h2>
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group mb-3">
              <label class="font-15 fw-medium mb-2" translate>first_name</label>
              <input type="text" class="form-control"
                [ngClass]="{ 'is-invalid':(f['firstname'].touched || isSubmitted) && f['firstname'].errors  }"
                formControlName="firstname" class="form-control" value="" placeholder="{{'first_name' | translate}}">
              <div *ngIf="(f['firstname'].touched || isSubmitted)  && f['firstname'].errors " class="invalid-feedback">
                <div *ngIf="f['firstname'].errors['required']" class="error"><span translate>firstname_req</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-3">
              <label class="font-15 fw-medium mb-2" translate>last_name</label>
              <input [ngClass]="{ 'is-invalid':(f['lastname'].touched || isSubmitted) && f['lastname'].errors  }"
                class="form-control" type="text" formControlName="lastname" value=""
                placeholder="{{'last_name' | translate}}">
              <div *ngIf="(f['lastname'].touched || isSubmitted)  && f['lastname'].errors " class="invalid-feedback">
                <div *ngIf="f['lastname'].errors['required']" class="error"><span translate>lastname_req</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-3">
              <label class="font-15 fw-medium mb-2" translate>your_email</label>
              <input type="email" formControlName="email" placeholder="{{'your_email' | translate}}"
                class="form-control"
                [ngClass]="{'is-invalid':(f['email'].touched || isSubmitted) && f['email'].errors}">
              <div *ngIf="(f['email'].touched || isSubmitted)  && f['email'].errors " class="invalid-feedback">
                <div *ngIf="f['email'].errors['required']" class="error">
                  <span translate>email_req</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group mb-3">
              <label class="font-15 fw-medium mb-2" translate>website_url</label>
              <input [ngClass]="{ 'is-invalid':(f['url'].touched || isSubmitted) && f['url'].errors  }"
                class="form-control" type="text" formControlName="url" value="" placeholder="{{'url' | translate}}">
              <div *ngIf="(f['url'].touched || isSubmitted)  && f['url'].errors " class="invalid-feedback">
                <div *ngIf="f['url'].errors['required']" class="error"><span translate>url_req</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group mb-3">
              <label class="font-15 fw-medium mb-2" translate>more_info</label>
              <!-- <input [ngClass]="{ 'is-invalid':(f['more_info'].touched || isSubmitted) && f['more_info'].errors  }"
                class="form-control" type="text" formControlName="more_info" value=""
                placeholder="Tell us about your project"> -->
              <textarea rows="1"
                [ngClass]="{ 'is-invalid':(f['more_info'].touched || isSubmitted) && f['more_info'].errors  }"
                class="form-control" type="text" formControlName="more_info" value=""
                placeholder="{{'tell-us-about-your-project' | translate}}"> </textarea>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="d-flex align-items-start align-items-md-center my-4">
              <div class="chk-wrapper ">
                <input type="checkbox" id="accept" class="checkbox">
                <label for="accept"></label>
              </div>
              <p class="font-15 fw-medium text-black mb-0" translate>agree <a
                  href="/assets/documents/Best_Wallet_Privacy_Policy.pdf" target="_blank"
                  class="text-primary text-decoration-none" translate>privacy_policy</a></p>
            </div>
          </div>
          <div class="col-lg-12">
            <button class="btn btn-primary w-100" type="submit">{{"apply" | translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
<app-footer></app-footer>